<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      size="small"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk
    </button>

    <a-modal v-model="visible" title="Bulk Upload Students" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Upload</a-button>
      </template>

      <a-form :form="form">
        <p class="mb-1">Select Subject to add students marks.</p>
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Subject"
            >
              <a-spin :spinning="subjectSpinning">
                <a-select
                  v-decorator="[
                    'subject_id',
                    {rules: [{ required: true, message: 'Please select a subject!!' }],}
                  ]"
                  placeholder="Select subject"
                >
                  <a-select-option v-for="examSubject in examSubjects" :value="examSubject.id" :key="examSubject.id">
                    {{examSubject.name}} ({{examSubject.abbreviation}})
                  </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

        </div>

        <a-divider />
        <p class="mt-3 mb-0">Download the CSV file format here.
          <a
            href="/resources/csv/neoskool_mark_bulk_import.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download CSV
          </a>
          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>
        </p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkUploadStudentMark',
  props: ['classSectionExamId'],
  mounted: function() {
    this.subjectSpinning = true
    this.$http.get(`/api/classsectionexam/${this.classSectionExamId}/subjects`)
      .then(({ data }) => {
        this.examSubjects = data.data
        this.subjectSpinning = false
      })
      .catch(error => {
        console.log(error)
      })
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      examSubjects: [],
      subjectSpinning: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload students marks!`,
            onOk: () => {
              values.class_section_exam_id = this.classSectionExamId
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/exam/marks/import', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Marks uploaded!',
                    description: `Bulk students marks import completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
